var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodataTopEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-nodata_top_employee"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nodata_top_employee",
    clipPath: "url(#clip-nodata_top_employee)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6258",
    "data-name": "Group 6258",
    transform: "translate(19533 -16429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bleach",
    transform: "translate(-19459.494 16511.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6250",
    "data-name": "Group 6250",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18370",
    "data-name": "Path 18370",
    d: "M51.5,77.089,28.684,39.057a3.155,3.155,0,0,0-5.41,0L.455,77.089a3.155,3.155,0,0,0,2.7,4.778H48.8A3.154,3.154,0,0,0,51.5,77.089Z",
    transform: "translate(0 -37.525)",
    fill: "#33bcaf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "flag",
    transform: "translate(-19474.234 16452.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6251",
    "data-name": "Group 6251",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18371",
    "data-name": "Path 18371",
    d: "M111.628,18.111l8.682-9.487a.862.862,0,0,0,.172-.92.92.92,0,0,0-.8-.517H91.791s-.345,0-.345.057V6.21a2.875,2.875,0,0,0,2.415-3.047A3.162,3.162,0,0,0,90.756,0a3.277,3.277,0,0,0-3.277,3.162A3.392,3.392,0,0,0,89.721,6.21v45.25a.862.862,0,1,0,1.725,0V29.036h28.231a.8.8,0,0,0,.8-.517.92.92,0,0,0-.172-.92Z",
    transform: "translate(-87.479 0)",
    fill: "#ffd400"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bleach-2",
    "data-name": "bleach",
    transform: "translate(-19509.006 16492.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6250-2",
    "data-name": "Group 6250",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18370-2",
    "data-name": "Path 18370",
    d: "M74.116,94.46,41.278,39.729a4.54,4.54,0,0,0-7.785,0L.654,94.46a4.54,4.54,0,0,0,3.893,6.875H70.223A4.539,4.539,0,0,0,74.116,94.46Z",
    transform: "translate(0 -37.525)",
    fill: "#34c6b7"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_721",
    "data-name": "Ellipse 721",
    cx: 1.615,
    cy: 1.615,
    r: 1.615,
    transform: "translate(-19509.016 16515.119)",
    fill: "#e0eaf6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_720",
    "data-name": "Ellipse 720",
    cx: 1.615,
    cy: 1.615,
    r: 1.615,
    transform: "translate(-19500.115 16451.15)",
    fill: "#e0eaf6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_723",
    "data-name": "Ellipse 723",
    cx: 1.615,
    cy: 1.615,
    r: 1.615,
    transform: "translate(-19421.129 16470.063)",
    fill: "#e0eaf6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_722",
    "data-name": "Ellipse 722",
    cx: 1.615,
    cy: 1.615,
    r: 1.615,
    transform: "translate(-19447.828 16501.213)",
    fill: "#e0eaf6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_724",
    "data-name": "Ellipse 724",
    cx: 4.397,
    cy: 4.397,
    r: 4.397,
    transform: "translate(-19417.791 16495.65)",
    fill: "#e0eaf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18373",
    "data-name": "Path 18373",
    d: "M527.4,62.47h0a9.45,9.45,0,0,0,7.394,7.395h0a9.468,9.468,0,0,0-7.394,7.4h0a9.459,9.459,0,0,0-7.4-7.4h0a9.441,9.441,0,0,0,7.395-7.395Z",
    transform: "translate(-20027.338 16411.484)",
    fill: "#e0eaf6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataTopEmployee);
export default __webpack_public_path__ + "static/media/nodata_top_employee.6df0187f1b8d6deb6acf3d776e1f1db3.svg";
export { ForwardRef as ReactComponent };